import { render } from "./App.vue?vue&type=template&id=625296fa"
const script = {}

import "./App.vue?vue&type=style&index=0&id=625296fa&lang=css"
script.render = render

export default script